/* eslint-disable no-underscore-dangle */
export const getAppVersion = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.__INITIAL_STATE__?.storeData?.version || null;
};
